<template>
  <div>
    <el-row class="el-container">
      <el-col>
        <h4>Quản lý người dùng</h4>
      </el-col>
      <el-col class="text-right">
        <el-dropdown>
          <el-button type="primary">Hành động</el-button>
          <el-dropdown-menu slot="dropdown">
<!--            <el-dropdown-item>-->
<!--              <div @click="getExportFile">-->
<!--                <FAIcon icon="fas fa-file-export" :color="Colors.RAW" />Xuất Excel-->
<!--              </div>-->
<!--            </el-dropdown-item>-->
            <el-dropdown-item divided>
              <div @click="$refs[refs.CREATE_SINGLE_USER_MODAL].showModal()">
                <FAIcon icon="fas fa-user" :color="Colors.RAW" />Tạo người dùng
              </div>
            </el-dropdown-item>
            <el-dropdown-item command="createBulkUser">
              <div @click="$refs[refs.CREATE_BATCH_USER_EXCEL_MODAL].showModal()">
                <FAIcon icon="fas fa-users" :color="Colors.RAW" />Nhập từ excel
              </div>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </el-col>
    </el-row>
    <AdminUserList :ref="refs.USER_TABLE" />
    <CreateSingleUserModal :ref="refs.CREATE_SINGLE_USER_MODAL" @success="reloadTable" />
    <CreateBatchUserExcelModal :ref="refs.CREATE_BATCH_USER_EXCEL_MODAL" @success="reloadTable" />
  </div>
</template>

<script>
import AdminUserList from '@/components/dashboard/user/AdminUserList.vue'
import FAIcon from '@/components/common/FAIcon.vue'
import CreateSingleUserModal from '@/components/dashboard/user/action-modals/CreateSingleUserModal.vue'
import { Colors } from '@/constants/DoITConstant.js'
import CreateBatchUserExcelModal from '@/components/dashboard/user/action-modals/CreateBatchUserExcelModal.vue'
import { apiGetDemoImportFileAsArrayBuffer } from '@/services/user_import_service'
import { pushArraybuffer2Client } from '@/helpers/DownloadHelper'
import { apiGetUserExportFileAsArrayBuffer } from '@/services/user_service'

export default {
  name: 'AdminUserManagement',
  components: { CreateBatchUserExcelModal, AdminUserList, FAIcon, CreateSingleUserModal },
  data() {
    return {
      Colors,
      refs: {
        CREATE_SINGLE_USER_MODAL: 'CREATE_SINGLE_USER_MODAL',
        CREATE_BATCH_USER_EXCEL_MODAL: 'CREATE_BATCH_USER_EXCEL_MODAL',
        USER_TABLE: 'USER_TABLE',
      },
    }
  },
  methods: {
    reloadTable() {
      this.$refs[this.refs.USER_TABLE].loadItems()
    },
    async getExportFile() {
      let res = await apiGetUserExportFileAsArrayBuffer()
      if (res == null) {
        this.$message({
          message: 'Có lỗi xảy ra',
          type: 'error'
        })
      } else {
        pushArraybuffer2Client(res, 'users.xlsx')
      }
    }
  },
}
</script>

<style scoped></style>
